let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kq0Mc"), load("5epKi"), load("joJy8"), load("aHE9G"), load("6XyGC")]).then(() => parcelRequire('cV69w'));